import { ICampaignCardProps } from "components/Atoms/CampaignCard/CampaignCardModel";
export enum ICampaignCarouselType {
  HOME,
  CAMPAIGN,
}
export interface IProps {
  data?: ICampaignCardProps[];
  type?: ICampaignCarouselType;
}
